export * from './renderer'
import { default as PopoverComponent } from './popover'

export default PopoverComponent
